import { REQUEST, SUCCESS, FAILURE } from './actions';

/* eslint-disable */
export const createReducer = (initialState, handlers, defaultHandler = null) =>
  (state = initialState, action) =>
    action && handlers.hasOwnProperty(action.type) ?
      handlers[action.type](state, action) : (defaultHandler ? defaultHandler (state, action) : state);

export const createSharedReducer = (initialState, handlers) =>
  (state = initialState, action, sharedState) =>
    action && handlers.hasOwnProperty(action.type) ?
      handlers[action.type](state, action, sharedState) : state;


const setTrue = () => true;
const setFalse = () => false;

export const createIsFetchingReducer = (initialState, apiActionTypes) => {
  const handlers = {};
  const currentlyFetching = {};

  apiActionTypes.forEach((type) => {
    handlers[type[REQUEST]] = setTrue;
    handlers[type[SUCCESS]] = setFalse;
    handlers[type[FAILURE]] = setFalse;
  });


  return (state = initialState, action) => {
    if (handlers.hasOwnProperty(action.type)) {
      const nextState = action && handlers.hasOwnProperty(action.type) ? handlers[action.type](state, action) : state;

      const actionTypeRoot = action.type.replace(/(_REQUEST|_SUCCESS|_FAILURE)/g, '');
      currentlyFetching[actionTypeRoot] = nextState;

      const rootTypes = Object.keys(currentlyFetching).filter(type => currentlyFetching[type] === true);

      return !!rootTypes.length;
    }

    return state;
  };

  // return createReducer(initialState, handlers);
};


const setStatus = status => () => status;

export const createStatusReducer = (initialState, apiActionTypes, routeActionTypes) => {
  const handlers = {};

  apiActionTypes.forEach((type) => {
    handlers[type[REQUEST]] = setStatus(REQUEST);
    handlers[type[SUCCESS]] = setStatus(SUCCESS);
    handlers[type[FAILURE]] = setStatus(FAILURE);
  });

  // routeActionTypes.forEach((type) => {
  //   handlers[type] = setStatus('');
  // });

  const apiStatus = createReducer(initialState, handlers);

  return (state, action) => {
    if (routeActionTypes.hasOwnProperty(action.type)) {
      return state || '';
    }

    return apiStatus(state, action);
  };
};



// WEBPACK FOOTER //
// ./src/helpers/reducers.js